<template>
    <div>
        <h3 class="text-center mt-3" style="font-weight:normal">Most Replaced QR By Vehicle Type</h3>
        <div style="overflow-y:scroll; max-height: 100%;">
            <table class=" table  h-100 w-100">
                <thead>
                    <th>No.</th>
                    <th >Vehicle Type</th>
                    <th >Count</th>
                </thead>
                <tbody v-for="(data, index) in datas">
                    <tr>
                        <td>{{index + 1}}</td>
                        <td>{{data.type ? data.type : "Unknown"}}</td>
                        <td>{{data.count}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props : ['datas']
}
</script>

<style scoped>
    th{
        text-align: center;
    }
    td{
        text-align: center;
    }
</style>
